import { Heading } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { TilesSelectGroup } from "../generic/TileSelectGroup";
import { getVehicleTransmissionTypesList } from "../../data/vehicle";
import { BrandType } from "@bus/models";

export const Transmission = () => {
    const { t } = useTranslation(["question3page"]);
    const brand = process.env.REACT_APP_WEBSITE_BRAND;
    const getTitle = () => {
        switch (brand) {
            case BrandType.CUPRA:
            case BrandType.SEAT:
                return t("question3page:transmission-type.titleAlternative")
            default:
                return t("question3page:transmission-type.titleAlternative");
        }
    }
    return (
        <>
            <Heading level={2} className="u-font-size-fs2">{getTitle()}</Heading>
            <TilesSelectGroup
                fieldName="transmissionType"
                list={getVehicleTransmissionTypesList(t)}
                className="u-1/2 u-1/2@l u-1/1@s TransmissionType"
            />
        </>
    );
};
